/* Compacta apenas o header; não interfere no custom element do tema. */
(() => {
  const init = () => {
    document.querySelectorAll('florescer-header.fl-header').forEach((header) => {
      if (header.dataset.fsStickyReady) return;
      header.dataset.fsStickyReady = '1';
      let scheduled = false;
      const update = () => {
        scheduled = false;
        header.classList.toggle('is-scrolled', window.scrollY > 8);
      };
      const onScroll = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(update);
      };
      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('pageshow', onScroll);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();